import { AdminKPIsClient } from '../EpdClient';
const client = new AdminKPIsClient(process.env.REACT_APP_API_URL);

class AdminKpiService {
  static getKpis = async () => {
    return client.get();
  };
}
export default AdminKpiService;
